import axios from "axios";

export default class PowerBIAccess {
  static getAccessToken = () => {
    const config = {
      method: "get",
      maxBodyLength: Infinity,
      url: "https://api.triskele.tech/api/v1/powerbi/token",
    };

    return axios.request(config);
  };

  static getPowerBIEmbeddedToken = (datasetId, reportId, azureToken) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${azureToken}`);

    const raw = JSON.stringify({
      datasets: [
        {
          id: datasetId,
        },
      ],
      reports: [
        {
          allowEdit: false,
          id: reportId,
        },
      ],
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
    };

    return fetch(
      "https://api.powerbi.com/v1.0/myorg/GenerateToken",
      requestOptions,
    );
  };

  static getReportById = (reportId, azureToken, groupId) => {
    const headers = {
      Authorization: `Bearer ${azureToken}`,
    };

    return fetch(
      `https://api.powerbi.com/v1.0/myorg/groups/${groupId}/reports/${reportId}`,
      {
        method: "GET",
        headers,
      },
    );
  };
}
